module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4205-8c0c615b0dfa87447636e07f20608187.jpg";